import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18nService } from '../../services/i18n.service';

interface Service {
  icon: string;
  title: string;
  description: string;
  features: string[];
}

@Component({
  selector: 'app-services',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './services.component.html',
  styleUrl: './services.component.scss'
})
export class ServicesComponent implements OnInit {
  services: Service[] = [
    {
      icon: 'fas fa-code',
      title: 'Web Development',
      description: 'Creating responsive and modern websites using latest technologies',
      features: ['Responsive Design', 'Modern Frameworks', 'Performance Optimization', 'SEO Friendly']
    },
    {
      icon: 'fas fa-server',
      title: 'Backend Development',
      description: 'Building robust server-side applications and APIs',
      features: ['.NET Core APIs', 'Database Design', 'Cloud Integration', 'Security Implementation']
    },
    {
      icon: 'fas fa-mobile-alt',
      title: 'Full-Stack Solutions',
      description: 'Complete web application development from frontend to backend',
      features: ['End-to-End Development', 'Database Integration', 'API Development', 'Deployment & Hosting']
    }
  ];

  constructor(public i18n: I18nService) {}

  ngOnInit(): void {
    this.i18n.initializeLanguage();
  }
}
